var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"myChart"}},[(_vm.isLoading)?_c('van-loading'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }